module.exports = __webpack_public_path__ + "static/media/Human-01.6120b01b.png";